clientType